import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import { Slider } from "components/DesignSystem/Slider/Slider";
import Tab from "components/DesignSystem/Tab/Tab";
import DashboardContainer from "components/dashboard/DashboardContainer";
import { ArrowLeft } from "components/icons/ArrowLeft";
import { Cross } from "components/icons/Cross";
import {
  CHAT_CARD_TYPE,
  OPEN_ITEM_CUSTOM_TYPE,
  REQUESTED_DOCUMENTS_CUSTOM_TYPE,
  REQUESTED_INFO_CUSTOM_TYPE,
  SENSITIVE_DATA_CUSTOM_TYPE,
  TICKET_CARD,
} from "constants/chatType";
import { usePaginatedMessages } from "hooks/usePaginatedMessages";
import { useDispatch, useSelector } from "react-redux";
import {
  closeActionCentreSlider,
  closeTicketSlider,
} from "store/slices/channelInfoSlider";
import { RootState } from "store/store";
import { useChannelStateContext, useChatContext } from "stream-chat-react";
import { ActionCentreList } from "./ActionCentreList";
import { useState } from "react";

export const ChatActionCentreSlider = ({
  block = false,
}: {
  block?: boolean;
}) => {
  const { client } = useChatContext();
  const { channel } = useChannelStateContext();
  const dispatch = useDispatch();
  const sliderOpen = useSelector(
    (store: RootState) => store.channelInfoSlider.showActionCentreSlier
  );
  const groupId = channel.data?.group_uuid! as string;
  const [selectTab, setSelectedTab] = useState<"PENDING" | "COMPLETED">(
    "PENDING"
  );

  const pendingActionMessageData = usePaginatedMessages(
    client,
    {
      id: channel.id,
    },
    {},
    { limit: 100 },
    {
      custom_type: {
        $in: [
          CHAT_CARD_TYPE,
          OPEN_ITEM_CUSTOM_TYPE,
          REQUESTED_DOCUMENTS_CUSTOM_TYPE,
          REQUESTED_INFO_CUSTOM_TYPE,
          SENSITIVE_DATA_CUSTOM_TYPE,
        ],
      },
      card_status: { $eq: "REQUESTED" },
    }
  );

  const completedActionMessageData = usePaginatedMessages(
    client,
    {
      id: channel.id,
    },
    {},
    { limit: 100 },
    {
      custom_type: {
        $in: [
          CHAT_CARD_TYPE,
          OPEN_ITEM_CUSTOM_TYPE,
          REQUESTED_DOCUMENTS_CUSTOM_TYPE,
          REQUESTED_INFO_CUSTOM_TYPE,
          SENSITIVE_DATA_CUSTOM_TYPE,
        ],
      },
      card_status: { $eq: "SUBMITTED" },
    }
  );

  const { messages, loadNextPage, next, loading } =
    selectTab === "PENDING"
      ? pendingActionMessageData
      : completedActionMessageData;
  const onOutslideSliderClick = () => {
    if (sliderOpen) {
      dispatch(closeActionCentreSlider());
    }
  };

  return (
    <Slider
      open={sliderOpen}
      className={classNames(
        "t-absolute !t-p-0 t-shadow-slider !t-h-full t-z-10",
        {
          "t-w-full": block,
          "t-w-[360px]": !block,
        }
      )}
      position="right"
      width={360}
    >
      <Tab.Root defaultValue="PENDING" className="t-h-full">
        <DashboardContainer className="t-h-full">
          <DashboardContainer.Header>
            <div className="t-py-3 t-pr-4 t-pl-5 t-flex t-justify-between t-items-center ">
              <div className="t-flex t-gap-2 t-items-center">
                <Button
                  customType="ghost_icon"
                  size="small"
                  onClick={onOutslideSliderClick}
                >
                  <span className="t-text-text-30">
                    <ArrowLeft size="16" />
                  </span>
                </Button>
                <span className="t-text-subtitle">Action centre</span>
              </div>
              <Button
                customType="ghost_icon"
                size="small"
                onClick={onOutslideSliderClick}
              >
                <Cross />
              </Button>
            </div>

            <div className="t-flex t-flex-col t-gap-4 t-px-5 t-pt-0 t-border-b t-border-0 t-border-solid t-border-i-neutral-10">
              <Tab.List className="t-flex t-gap-2">
                <Tab.Trigger
                  value="PENDING"
                  onClick={() => setSelectedTab("PENDING")}
                >
                  <span className="t-text-body">Pending</span>
                </Tab.Trigger>
                <Tab.Trigger
                  value="COMPLETED"
                  onClick={() => setSelectedTab("COMPLETED")}
                >
                  <span className="t-text-body">Completed</span>
                </Tab.Trigger>
              </Tab.List>
            </div>
          </DashboardContainer.Header>
          <DashboardContainer.Content
            className="t-p-5 t-pt-4"
            id="media-scroll"
          >
            <div className="t-flex t-flex-col t-gap-4 t-h-full">
              <div className="t-h-full">
                <Tab.Content value="PENDING" className="t-h-full">
                  <ActionCentreList
                    //  @ts-ignore
                    actionMessageItems={messages.map((ticket) => ({
                      message: {
                        ...ticket.message,
                        custom_data: ticket.message.custom_data || {},
                      },
                    }))}
                    loadNextPage={loadNextPage}
                    next={Boolean(next)}
                    groupId={groupId}
                    emptyStateText="No actions pending"
                  />
                </Tab.Content>
                <Tab.Content value="COMPLETED" className="t-h-full">
                  <ActionCentreList
                    //  @ts-ignore
                    actionMessageItems={messages.map((ticket) => ({
                      message: {
                        ...ticket.message,
                        custom_data: ticket.message.custom_data || {},
                      },
                    }))}
                    loadNextPage={loadNextPage}
                    next={Boolean(next)}
                    groupId={groupId}
                    completed
                    emptyStateText="No actions completed"
                  />
                </Tab.Content>
              </div>
            </div>
          </DashboardContainer.Content>
        </DashboardContainer>
      </Tab.Root>
    </Slider>
  );
};
